const confrimEmailStyle = () => ({
	root: {
		height: "100%",
		width: "100%",
		margin: 0,
		padding: 0,
	},
	container: {
		display: "block",
	},
	vertical_center: {
		display: "flex",
		marginTop: "100px",
		justifyContent: "center",
		alignItems: "center",
	},
	button: {
		width: "auto",
		display: "flex",
		margin: "auto",
	},

	textField: {
		width: 250,
		margin: "auto",
	},
});

export default confrimEmailStyle;
